//@ts-nocheck
import { Outlet, Route, Routes } from 'react-router-dom';
import PageNotFound from '../pages/ErrorPage/PageNotFound';
import Inbox from '../pages/Inbox/Inbox';
import PrivateRoute from './PrivateRoute';
import DashboardLayout from '../layouts/DashboardLayout';
import Contact from '../pages/Contact/Contact';
import QuickEmail from '../pages/QuickEmail/QuickEmail';
import EmailCampaign from '../pages/EmailCampaign/EmailCampaign';
import QuickSms from '../pages/QuickSms/QuickSms';
import SmsCampaign from '../pages/SmsCampaign/SmsCampaign';
import Billing from '../pages/Billing/Billing';
import Overview from '../pages/Overview/Overview';
import SmsCampaignCreate from '../components/SmsCampaign/SmsCampaignCreate/SmsCampaignCreate';
import EmailCampaignUpdate from '../components/EmailCampaign/EmailCampaignUpdate';
import SmsCampaignUpdate from '../components/SmsCampaign/SmsCampaignUpdate/SmsCampaignUpdate';
import CreateContacts from '../components/Contacts/CreateContacts/CreateContacts';
import History from '../pages/History/History';
import Settings from '../pages/Settings/Settings';
import CreateEmailCampaign from '../pages/EmailCampaign/CreateEmailCampaign';
import EditEmailCampaign from '../pages/EmailCampaign/EditEmailCampaign';
import CreateSmsCampaign from '../pages/SmsCampaign/CreateSmsCampaign';
import EditSmsCampaign from '../pages/SmsCampaign/EditSmsCampaign';

const Router = () => {
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route path={'/email-sms-marketing'} element={<Outlet></Outlet>}>
          <Route index element={<Overview />} />
          <Route path={'contact'} element={<Outlet></Outlet>}>
            <Route index element={<Contact />}></Route>
          </Route>
          <Route path={'quick-email'} element={<QuickEmail />} />
          <Route path={'email-campaign'} element={<Outlet></Outlet>}>
            <Route index element={<EmailCampaign />} />
            <Route path='create' element={<CreateEmailCampaign />} />
            <Route path='edit/:id' element={<EditEmailCampaign />} />
          </Route>
          <Route path={'quick-sms'} element={<QuickSms />} />
          <Route path={'sms-campaign'} element={<Outlet></Outlet>}>
            <Route index element={<SmsCampaign />}></Route>
            <Route path='create' element={<CreateSmsCampaign />} />
            <Route path='edit/:id' element={<EditSmsCampaign />} />
          </Route>

          {/* <Route path={"billing"} element={<Billing />} /> */}
          <Route path={'history'} element={<History />} />
          <Route path={'settings'} element={<Settings />} />
        </Route>

        <Route path='/*' element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default Router;
